'use client';

import { useMediaQuery } from '@mui/material';
import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';
import React from 'react';

import { StrapiCarrier } from '@/apis/strapi';
import { doTranslation } from '@/app/i18n/client';
import CarrierLogo from '@/components/global/carrier-logo/carrier-logo';
import { CarrierImage } from '@/utils/carriers';

const CarrierReview = dynamic(() => import('@/components/schedule-results/carrier-review'), { ssr: false });

import styles from '@/components/schedule-results/carrier.module.scss';

type Props = {
  index: number;
  carrierImages: { [key: string]: CarrierImage };
  uniqueCarriers: any;
  carrier: any;
  strapiCarrier?: StrapiCarrier | null;
  upcomingTrips?: boolean | null;
};

const Carrier = (props: Props): React.JSX.Element => {
  const { lng }: any = useParams();
  const { carrier, carrierImages, index, uniqueCarriers, upcomingTrips, strapiCarrier } = props;
  const isMobile = useMediaQuery('(max-width: 600px)');

  const { t } = doTranslation(lng);

  return (
    <div className={styles.carrier}>
      {uniqueCarriers.length === 2 ? (
        <>
          <span className={styles.label}>
            {isMobile && !upcomingTrips ? `${t('Carriers')}:` : t('Multiple Carriers:')}
          </span>
          {isMobile && upcomingTrips ? (
            <></>
          ) : (
            uniqueCarriers.map((uc: any, index: number) => (
              <div className={styles.logo} key={uc.code}>
                {carrierImages[uc.code] ? (
                  <div className={styles.logo}>
                    <CarrierLogo carrierImage={carrierImages[uc.code]} />
                  </div>
                ) : (
                  <span key={uc.code} className={styles.text}>
                    {carrier?.name}
                  </span>
                )}
                {index < uniqueCarriers.length - 1 && <span className={styles.label}>+</span>}
              </div>
            ))
          )}
        </>
      ) : uniqueCarriers.length >= 2 ? (
        <span className={styles.label}>{t('Multiple Carriers')}</span>
      ) : carrier ? (
        <>
          <span className={styles.label}>{t('Carrier')}:</span>
          {carrierImages[carrier.code] ? (
            <div className={styles.logo}>
              <CarrierLogo carrierImage={carrierImages[carrier.code]} />
            </div>
          ) : (
            <span className={styles.text}>{carrier.name}</span>
          )}
          {strapiCarrier && strapiCarrier.attributes.aggregate_rating && (
            <CarrierReview
              activeIndex={index}
              index={index}
              place="right"
              carrier={strapiCarrier}
              carrierImages={carrierImages}
              tripDetails={false}
            />
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Carrier;
